import { render, staticRenderFns } from "./FeatureReporting.vue?vue&type=template&id=45b7f211&scoped=true"
import script from "./FeatureReporting.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureReporting.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7f211",
  null
  
)

export default component.exports